import React from 'react';
import Skeleton from './Skeleton';
import '../../assets/styles/product.card.css';

const ProductCardSkeleton = () => (
  <div className="product-card card p-2 shadow-sm animate-pulse" style={{ minWidth: 180, maxWidth: 260, width: '100%', borderRadius: 16 }}>
    <div className="position-relative mb-2" style={{ width: '100%', paddingTop: '100%', borderRadius: 12, overflow: 'hidden' }}>
      <Skeleton style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: 12 }} />
    </div>
    <div className="d-flex flex-column gap-2">
      <Skeleton width="70%" height="1.2em" style={{ marginBottom: 4 }} />
      <Skeleton width="50%" height="1em" />
      <Skeleton width="40%" height="1em" />
      <div className="d-flex gap-2 align-items-center mt-2">
        <Skeleton width="32px" height="32px" borderRadius="50%" />
        <Skeleton width="32px" height="32px" borderRadius="50%" />
      </div>
    </div>
  </div>
);

export default ProductCardSkeleton;
